export const iconFontAwesomeMedicalHealthEyeDropper = (
	<i className="fa-solid fa-eye-dropper"></i>
);
